import { Avatar } from '@mui/material'
import React, { useState } from 'react'
import { getInitials } from '../../shared/shared'
import rightsidebarstyles from '../../../css/connect.module.css'
import { FaHistory } from "react-icons/fa";
import { PiStopCircleFill } from "react-icons/pi";
import BotFlowHistory from './BotFlowHistory';
import Alerts from '../../shared/Alerts';
import { stopSupport } from '../../shared/AlertMessages';
import { END_LIVE_SUPPORT } from '../../shared/Constant';

const RightSidebarChat = ({selectedUser,selectedMessages,input,setInput,handleSend,selectedUserId,livesupportDatas,updateLiveSupport,selectedDetails,handlePostMessage}) => {

  const [isHistory,setIsHistory]= useState(false);
  const [isStopped,setIsStopped]= useState(false);
console.log(livesupportDatas,"livesupportDatas")
const handleConfirm = () => {
  handlePostMessage(
    selectedDetails.channel_id,
    selectedDetails.groupName,
    selectedUserId,
    END_LIVE_SUPPORT,
    selectedDetails.external_id
  );
};
  return (
            <div className={`col-md-6 ${rightsidebarstyles.chatcontainer}`} 
            >
          <div className={`${rightsidebarstyles.chatheader} d-flex align-items-center gap-2`}>
            {selectedUser && (
              <>
<div className="d-flex align-items-center justify-content-between w-100">
  {/* Left side: Avatar + Name */}
  <div className="d-flex align-items-center gap-2">
    {selectedUser && (
      <>
        <Avatar
          src={selectedUser.profileUrl}
          alt={selectedUser.name}
          sx={{ width: 32, height: 32 }}
        >
          {getInitials(selectedUser.name)}
        </Avatar>
        <h5 className="m-0">{selectedUser.name}</h5>
      </>
    )}
  </div>

  {/* Right side: History Icon */}
<div className="d-flex align-items-center gap-2">
  {livesupportDatas?.live_support_handoff && (
    <PiStopCircleFill
      style={{ cursor: "pointer" }}
      size={24}
      onClick={
        () =>{ 
          setIsStopped(true)
          handlePostMessage(selectedDetails.channel_id,selectedDetails.groupName,selectedUserId,END_LIVE_SUPPORT,selectedDetails.external_id)
        }
        }
    />
  )}

<FaHistory style={{ cursor: "pointer" }} size={20}  onClick={() => setIsHistory(true)} />
</div>
</div>

              </>
            )}
          </div>

          <div className={`${rightsidebarstyles.messagescontainer} custom-scrollBar`}>
            {selectedMessages.map((msg, index) => (
              <div
                key={index}
                className={`d-flex ${msg.sender === "me" ? "justify-content-end" : "justify-content-start"}`}
                
              >
                <div className={`${rightsidebarstyles.messagebubble} ${msg.sender === "me" ? `${rightsidebarstyles.sentmessage}` :  `${rightsidebarstyles.receivedmessage}`}`}
                 
                >
              
                    {msg.text}
              
                </div>
              </div>
            ))}
          </div>

          <div className={rightsidebarstyles.chatfooter}>
            <div className="input-group">
              <input
                className="form-control"
                value={input}
                onChange={(e) => setInput(e.target.value)}
                placeholder="Type a message..."
                onKeyDown={(e) => e.key === "Enter" && handleSend()}
              />
              <button className="btn btn-primary" onClick={handleSend}>
                Send
              </button>
            </div>
          </div>


         <BotFlowHistory open={isHistory} setOpen={setIsHistory} session_id={selectedUserId}/>
         {/* {isStopped && <Alerts  antTitle={stopSupport.text} antContent={stopSupport.content} antOkText={stopSupport.confirm} antCancelText={stopSupport.cancel}  setShowConfirmModal={setIsStopped} confirmMsgText={stopSupport.confirmtext} id={livesupportDatas?.support_session} action={updateLiveSupport}/>} */}

          {isStopped && <Alerts  antTitle={stopSupport.text} antContent={stopSupport.content} antOkText={stopSupport.confirm} antCancelText={stopSupport.cancel}  setShowConfirmModal={setIsStopped} confirmMsgText={stopSupport.confirmtext} id={livesupportDatas?.support_session} action={updateLiveSupport}/>}
        </div>
  )
}

export default RightSidebarChat
